import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Paper} from '@material-ui/core';
import { ReportConnectDisconnectFilter } from './ReportConnectDisconnectFilter';
import { ReportConnectDisconnectList } from './ReportConnectDisconnectList';
import SqlRequest from '../../../../api/sql/SqlRequest';
import { base64toGuid, getObjectByID } from '../../../../api/helpers';
import NativeTable from '../../../../api/sql/NativeTable';


class ReportConnectDiscopnnectPanel_ extends React.Component {

    constructor(props) {
        super(props)

        const time = new Date()
        const dateFrom = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0 )
        const dateTo = new Date(time.getFullYear(), time.getMonth(), time.getDate()+1, 0, 0 )
        

        this.state = {
            filter: {
                dateFrom: dateFrom,
                dateTo: dateTo,
                networkID: props.networkID,
                userID: null,
                user: ''
            },
            reportData: {columns:[], rows:[]}
        }

        this.handleFilterChange = this.handleFilterChange.bind(this)

        this.handleQueryComplete = this.handleQueryComplete.bind(this)

        this.handleAction = this.handleAction.bind(this)

        this.handleReportRequestComplete = this.handleReportRequestComplete.bind(this)
    }
    
    componentDidMount(){
        this.handleFilterChange(this.state.filter)
    }

    handleFilterChange(filter){
        this.setState({filter: filter})
        console.log('filter:')
        console.log(filter)
    }


    handleQueryComplete(events){
        //alert('query complete')
        console.log('handleQueryComplete')
        console.log(events)
        this.setState({events: events})
    }

    handleAction(action){
        switch(action.type){

            case 'FILTER_CHANGE':{
                //alert('FILTER_CHANGE')

                this.setState({filter: action.filter})
                break
            }
            case 'FILTER_APPLY':{

                //alert('FILTER_APPLY')

                let f = action.filter
                const dateFrom = f.dateFrom.getTime()
                const dateTo = f.dateTo.getTime()

                console.log('action.filter')
                console.log(action.filter)

                console.log('this.props')
                console.log(this.props)

                console.log('dateFrom')
                console.log(dateFrom)
                console.log('dateTo')
                console.log(dateTo)

                let networkID = f.networkID ? f.networkID : this.props.networkID 

                const sqlRequest = new SqlRequest(networkID, this.handleReportRequestComplete)

                let where = ' 1=1 '

                if(f.userID){
                    where += " and userid ='" + base64toGuid(f.userID) + "'";
                }

                if(f.dateFrom){
                    where +=  " and dt >= @p1 "
                    const ext1 = sqlRequest.parameterExtension('System.DateTime', "p1", dateFrom)
                    sqlRequest.addExtension("selectConnectDisconnect", ext1)
                }
                if(f.dateTo){
                    where +=  " and dt <= @p2 "
                    const ext2 = sqlRequest.parameterExtension('System.DateTime', "p2", dateTo)
                    sqlRequest.addExtension("selectConnectDisconnect", ext2)
                }
                

                let sql = "SELECT TOP 10000 dt, userName, CASE isDispatcher WHEN 1 THEN 'x' WHEN 0 THEN ' ' END as dispatcher, event, manufacturer, model "+
                          "from events inner join devices on events.deviceid=devices.id "+
                          "WHERE " + where;
      
                console.log(sql)

                sqlRequest.addQuery("selectConnectDisconnect", sql)

                
                //this.api.querySql(sqlRequest)

                this.props.onAction({type: 'SQL_REQUEST', request: sqlRequest })


                
                break
            }

        }
    }

    handleReportRequestComplete(results){

        console.log('handleReportRequestComplete')

        console.log(results)

        const data = getObjectByID('selectConnectDisconnect', results, 'Key')

        console.log('data')
        console.log(data)

        const table = new NativeTable(data.Result)

        const dataTable = table.toDataTable()

        console.log('dataTable')
        console.log(dataTable)

        this.setState({reportData: dataTable})

    }



    render(){

        return(
            <Paper style={{marginBottom:16}}>
                <ReportConnectDisconnectFilter networks={this.props.networks} 
                    onAction={this.handleAction} onChange={this.handleFilterChange} filter={this.state.filter}/>
                <ReportConnectDisconnectList reportData={this.state.reportData} />
            </Paper>
        );
            //eventLogger={this.props.eventLogger} filter={this.state.filter}
    }

}

export const ReportConnectDiscopnnectPanel = withTranslation()(ReportConnectDiscopnnectPanel_);